import {
  JobPhaseBumpApprovalStatus,
  RepairPaymentTypeEnum,
} from '@vatos-pas/common';

/**
 * Bump has been resolved by a supervisor (no further approval action).
 */
export const isApprovedStatus = (
  status: JobPhaseBumpApprovalStatus | undefined,
): boolean =>
  status === JobPhaseBumpApprovalStatus.APPROVED ||
  status === JobPhaseBumpApprovalStatus.MISMATCH_APPROVAL ||
  status === JobPhaseBumpApprovalStatus.OVERRIDDEN;

/**
 * Minimal row shape for the pending-hourly check. Fields are optional because
 * repair payables sheet rows only carry them once the backend ships its half;
 * a row without them reads as "not an hourly payout".
 */
export type PendingHourlyPayoutRecord = {
  repairPaymentType?: RepairPaymentTypeEnum | null;
  bumperApprovalStatus?: JobPhaseBumpApprovalStatus;
};

/**
 * Hourly payouts are estimate-based until a supervisor approves the hours,
 * so the value is shown greyed out while approval is pending. DEPRECATED rows
 * never enter the approval workflow (legacy flow stamps approved hours at
 * creation), so their payout is final and never greyed.
 */
export const isPendingHourlyPayout = (
  record: PendingHourlyPayoutRecord | undefined,
): boolean =>
  record?.repairPaymentType === RepairPaymentTypeEnum.PerHour &&
  !isApprovedStatus(record.bumperApprovalStatus) &&
  record.bumperApprovalStatus !== JobPhaseBumpApprovalStatus.DEPRECATED;
